import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { Fonts } from '../../../utils/resources/fonts';
import { Colors } from '../../../utils/resources/colors';

export interface NavBlockCSSStyle extends UIComponentCSSStyle
{
    getTitleCSSStyle(): object;
    getUnorderListCSSStyle(): object;
    getListItemCSSStyle(): object;
    getAnchorCSSStyle(): object;
}

export class NavBlockCSSStyleImpl extends UIComponentCSSStyleImpl implements NavBlockCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
                    paddingLeft: '10px', 
                    paddingRight: '10px', 
                    paddingTop: '43px'
                };
    }

    getTitleCSSStyle(): object {
        return {
                    fontFamily: this.getResources().getFontFamily(), 
                    fontSize: this.getResources().getFont(Fonts.h9), 
                    color: this.getResources().getColor(Colors.color_16), 
                    display: 'flex', 
                    justifyContent: "flex-start"
                };
    }

    getUnorderListCSSStyle(): object {
        return {
                margin: '0px', 
                padding: '0px', 
                listStyleType: 'none'
            };
    }

    getListItemCSSStyle(): object {
        return {
                    display: 'flex', 
                    justifyContent: "flex-start"
                };
    }

    getAnchorCSSStyle(): object {
        return {
                    lineHeight: '20px', 
                    letterSpacing: "-0.08px",
                    fontFamily: this.getResources().getFontFamily(), 
                    fontSize: this.getResources().getFont(Fonts.h6), 
                    color: this.getResources().getColor(Colors.color_5), 
                };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/footer-native/navblockcss.tsx